// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "af1cc8c27e617ec99bf38545d2fb6c89a9ff8328/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"2a9a7941","581":"e1bbb2aa","688":"2b6b0509","774":"24c5a21d"}[chunkId] + ".chunk.js";
};